/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_InvestorFirmsQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmGridSortInput> | Types.InvestorFirmGridSortInput
  >;
  where?: Types.InputMaybe<Types.InvestorFirmGridFilterInput>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type CrmManagement_InvestorFirmsQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly totalCount: number;
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly linkedCmgEntityName?: string | null;
      readonly crd?: string | null;
      readonly createdByUserName?: string | null;
      readonly createdOn: string;
      readonly description?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly factSet?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly firmKey?: string | null;
      readonly id: string;
      readonly firmSubType?: string | null;
      readonly firmType?: string | null;
      readonly isOnPlatform: boolean;
      readonly isLinked: boolean;
      readonly lei?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly mpid?: string | null;
      readonly name: string;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly investorContactsCount: number;
      readonly salesCoverageCount: number;
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
        }> | null;
      } | null;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type CrmManagement_AdminInvestorFirmsQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmGridSortInput> | Types.InvestorFirmGridSortInput
  >;
  where?: Types.InputMaybe<Types.InvestorFirmGridFilterInput>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  tenantId: Types.Scalars['UUID']['input'];
}>;

export type CrmManagement_AdminInvestorFirmsQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorFirmsGrid?: {
    readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
    readonly totalCount: number;
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly cik1?: string | null;
      readonly cik2?: string | null;
      readonly linkedCmgEntityKey?: string | null;
      readonly linkedCmgEntityName?: string | null;
      readonly crd?: string | null;
      readonly createdByUserName?: string | null;
      readonly createdOn: string;
      readonly description?: string | null;
      readonly emailAddress1?: string | null;
      readonly emailAddress2?: string | null;
      readonly factSet?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly firmKey?: string | null;
      readonly id: string;
      readonly firmSubType?: string | null;
      readonly firmType?: string | null;
      readonly isOnPlatform: boolean;
      readonly isLinked: boolean;
      readonly lei?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly mpid?: string | null;
      readonly name: string;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly website1?: string | null;
      readonly website2?: string | null;
      readonly investorContactsCount: number;
      readonly salesCoverageCount: number;
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
        }> | null;
      } | null;
      readonly salesCoverage?: {
        readonly __typename?: 'SalesCoverageCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmRelationship';
          readonly employeeName?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type InvestorFirmFragment = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly address1?: string | null;
  readonly address2?: string | null;
  readonly cik1?: string | null;
  readonly cik2?: string | null;
  readonly linkedCmgEntityKey?: string | null;
  readonly linkedCmgEntityName?: string | null;
  readonly crd?: string | null;
  readonly createdByUserName?: string | null;
  readonly createdOn: string;
  readonly description?: string | null;
  readonly emailAddress1?: string | null;
  readonly emailAddress2?: string | null;
  readonly factSet?: string | null;
  readonly fax1?: string | null;
  readonly fax2?: string | null;
  readonly firmKey?: string | null;
  readonly id: string;
  readonly firmSubType?: string | null;
  readonly firmType?: string | null;
  readonly isOnPlatform: boolean;
  readonly isLinked: boolean;
  readonly lei?: string | null;
  readonly modifiedByUserName?: string | null;
  readonly modifiedOn: string;
  readonly mpid?: string | null;
  readonly name: string;
  readonly phone1?: string | null;
  readonly phone2?: string | null;
  readonly status: Types.RolodexRecordStatus;
  readonly website1?: string | null;
  readonly website2?: string | null;
  readonly investorContactsCount: number;
  readonly salesCoverageCount: number;
  readonly investorContacts?: {
    readonly __typename?: 'InvestorContactsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmContact';
      readonly investorEmployeeId: string;
      readonly name: string;
      readonly email1?: string | null;
    }> | null;
  } | null;
  readonly salesCoverage?: {
    readonly __typename?: 'SalesCoverageCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmRelationship';
      readonly employeeName?: string | null;
    }> | null;
  } | null;
};

export type InvestorContactFragment = {
  readonly __typename?: 'InvestorFirmContact';
  readonly investorEmployeeId: string;
  readonly name: string;
  readonly email1?: string | null;
};

export const InvestorContactFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvestorFirmFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mpid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorContactsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorContact' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salesCoverageCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_InvestorFirmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_InvestorFirms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmGridSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmGridFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorFirm' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mpid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorContactsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorContact' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salesCoverageCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_InvestorFirmsQuery__
 *
 * To run a query within a React component, call `useCrmManagement_InvestorFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_InvestorFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_InvestorFirmsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCrmManagement_InvestorFirmsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >(CrmManagement_InvestorFirmsDocument, options);
}
export function useCrmManagement_InvestorFirmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >(CrmManagement_InvestorFirmsDocument, options);
}
// @ts-ignore
export function useCrmManagement_InvestorFirmsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirmsQuery,
  CrmManagement_InvestorFirmsQueryVariables
>;
export function useCrmManagement_InvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirmsQuery,
        CrmManagement_InvestorFirmsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorFirmsQuery | undefined,
  CrmManagement_InvestorFirmsQueryVariables
>;
export function useCrmManagement_InvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorFirmsQuery,
        CrmManagement_InvestorFirmsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_InvestorFirmsQuery,
    CrmManagement_InvestorFirmsQueryVariables
  >(CrmManagement_InvestorFirmsDocument, options);
}
export type CrmManagement_InvestorFirmsQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirmsQuery
>;
export type CrmManagement_InvestorFirmsLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirmsLazyQuery
>;
export type CrmManagement_InvestorFirmsSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorFirmsSuspenseQuery
>;
export type CrmManagement_InvestorFirmsQueryResult = Apollo.QueryResult<
  CrmManagement_InvestorFirmsQuery,
  CrmManagement_InvestorFirmsQueryVariables
>;
export const CrmManagement_AdminInvestorFirmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AdminInvestorFirms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmGridSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmGridFilterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorFirm' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorFirm' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cik2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedCmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'crd' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'factSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmSubType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lei' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mpid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorContactsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'EnumValue', value: 'EFFECTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InvestorContact' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'salesCoverageCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'employeeName' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AdminInvestorFirmsQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AdminInvestorFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AdminInvestorFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AdminInvestorFirmsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCrmManagement_AdminInvestorFirmsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  > &
    (
      | { variables: CrmManagement_AdminInvestorFirmsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  >(CrmManagement_AdminInvestorFirmsDocument, options);
}
export function useCrmManagement_AdminInvestorFirmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  >(CrmManagement_AdminInvestorFirmsDocument, options);
}
// @ts-ignore
export function useCrmManagement_AdminInvestorFirmsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminInvestorFirmsQuery,
  CrmManagement_AdminInvestorFirmsQueryVariables
>;
export function useCrmManagement_AdminInvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminInvestorFirmsQuery,
        CrmManagement_AdminInvestorFirmsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminInvestorFirmsQuery | undefined,
  CrmManagement_AdminInvestorFirmsQueryVariables
>;
export function useCrmManagement_AdminInvestorFirmsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminInvestorFirmsQuery,
        CrmManagement_AdminInvestorFirmsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AdminInvestorFirmsQuery,
    CrmManagement_AdminInvestorFirmsQueryVariables
  >(CrmManagement_AdminInvestorFirmsDocument, options);
}
export type CrmManagement_AdminInvestorFirmsQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorFirmsQuery
>;
export type CrmManagement_AdminInvestorFirmsLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorFirmsLazyQuery
>;
export type CrmManagement_AdminInvestorFirmsSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorFirmsSuspenseQuery
>;
export type CrmManagement_AdminInvestorFirmsQueryResult = Apollo.QueryResult<
  CrmManagement_AdminInvestorFirmsQuery,
  CrmManagement_AdminInvestorFirmsQueryVariables
>;
